import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'angular-lib';

@Component({
    selector: 'ez-index',
    template: require('./index.component.html'),
    styles: [require('./index.component.less')]
})
export class IndexComponent {

    constructor(private router: Router) {}

    public logout() {
        AuthService.logout();
        this.router.navigate(['/login']);
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./src/app/components/account/index/index.component.ts